import styled, { css } from 'styled-components'
import TypeScales from './typescales'

interface ParagraphProps {
  align?: 'left' | 'center' | 'right' | 'justify'
}

export default styled(TypeScales.body1).attrs<ParagraphProps>((props) => ({
  as: 'p',
  align: props.align,
}))<ParagraphProps>`
  margin: 1.25rem 0;

  ${({ align }) =>
    align &&
    css`
      text-align: ${align};
    `}
`
